import GalileiForm from './GalileiForm.vue';
import GalileiView from './GalileiView.vue';
import KeratoscopyForm from './KeratoscopyForm.vue';
import KeratoscopyView from './KeratoscopyView.vue';
import OctMaculaForm from './OctMaculaForm.vue';
import OctMaculaView from './OctMaculaView.vue';
import OctOpticDiscForm from './OctOpticDiscForm.vue';
import OctOpticDiscView from './OctOpticDiscView.vue';
import PachymetryForm from './PachymetryForm.vue';
import PachymetryView from './PachymetryView.vue';
import VisualAcuityForm from './VisualAcuityForm.vue';
import VisualAcuityView from './VisualAcuityView.vue';
import RetinographyForm from './RetinographyForm.vue';
import RetinographyView from './RetinographyView.vue';
import MicroscopyForm from './MicroscopyForm.vue';
import MicroscopyView from './MicroscopyView.vue';
import BiometryForm from './BiometryForm.vue';
import BiometryView from './BiometryView.vue';
import VisualFieldForm from './VisualFieldForm.vue';
import VisualFieldView from './VisualFieldView.vue';
import OpdForm from './OpdForm.vue';
import OpdView from './OpdView.vue';
import RetinaMappingForm from './RetinaMappingForm.vue';
import RetinaMappingView from './RetinaMappingView.vue';

// eslint-disable-next-line import/prefer-default-export
export const exams = Object.freeze([
  {
    key: 'galilei',
    name: 'Galilei',
    form: GalileiForm,
    view: GalileiView,
  },
  {
    key: 'keratoscopy',
    name: 'Ceratoscopia',
    form: KeratoscopyForm,
    view: KeratoscopyView,
  },
  {
    key: 'oct_macula',
    name: 'OCT Macula',
    form: OctMaculaForm,
    view: OctMaculaView,
  },
  {
    key: 'oct_optic_disc',
    name: 'OCT Papila',
    form: OctOpticDiscForm,
    view: OctOpticDiscView,
  },
  {
    key: 'pachymetry',
    name: 'Paquimetria',
    form: PachymetryForm,
    view: PachymetryView,
  },
  {
    key: 'visual_acuity',
    name: 'Acuidade Visual (P.A.M)',
    form: VisualAcuityForm,
    view: VisualAcuityView,
  },
  {
    key: 'retinography',
    name: 'Retinografia',
    form: RetinographyForm,
    view: RetinographyView,
  },
  {
    key: 'microscopy',
    name: 'Microscopia',
    form: MicroscopyForm,
    view: MicroscopyView,
  },
  {
    key: 'biometry',
    name: 'Biometria',
    form: BiometryForm,
    view: BiometryView,
  },
  {
    key: 'visual_field',
    name: 'Campo Visual',
    form: VisualFieldForm,
    view: VisualFieldView,
  },
  {
    key: 'opd',
    name: 'OPD',
    form: OpdForm,
    view: OpdView,
  },
  {
    key: 'retina_mapping',
    name: 'Mapeamento de Retina',
    form: RetinaMappingForm,
    view: RetinaMappingView,
  },
]);
